export default __webpack_public_path__ + "static/media/fried.7b5253fc.png";